import { useLingui } from '@lingui/react'

import type { I18nLanguage } from '@twistopayments/design-system/base'
import { useDesignSystem } from '@twistopayments/design-system/base'
import { formatCurrencyNumber } from '@twistopayments/design-system/utils'

type FormattedCurrencyNumberProps = {
  value: number | string
} & Parameters<typeof formatCurrencyNumber>[1]

export const FormattedCurrencyNumber = ({
  value,
  currency,
  ...options
}: FormattedCurrencyNumberProps) => {
  const {
    i18n: { locale },
  } = useLingui()
  const { currencyCode: regionCurrencyCode, currencyLocale } = useDesignSystem()

  return (
    <>
      {formatCurrencyNumber(currencyLocale ?? (locale as I18nLanguage), {
        ...options,
        currency: currency ?? regionCurrencyCode,
        style: 'currency',
      })(value)}
    </>
  )
}
